import { render, staticRenderFns } from "./DrawerHandles.vue?vue&type=template&id=898d9cd8&scoped=true&"
import script from "./DrawerHandles.vue?vue&type=script&lang=js&"
export * from "./DrawerHandles.vue?vue&type=script&lang=js&"
import style0 from "./DrawerHandles.vue?vue&type=style&index=0&id=898d9cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d9cd8",
  null
  
)

export default component.exports